'use strict';

var useTheme$1 = require('../../node_modules/@material-ui/core/styles/useTheme.js');

var useTheme = useTheme$1;

module.exports = useTheme;
